import React from 'react';
import PropTypes from 'prop-types';
import styles from './RichText.module.less';

const RichText = ({
  element,
  qid,
}) => {
  function createMarkup() {
    return {__html: element.description};
  }
  return (
    <section
      className={styles.vpRichText}
      dangerouslySetInnerHTML={createMarkup()}
    />
  );
}

RichText.propTypes = {};

export default RichText;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/RichText.jsx